import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Component from 'vue-class-component';

import Layout from '@/views/Layout.vue';
import UserLayout from '@/views/user/Layout.vue';
import AdminLayout from '@/views/admin/Layout.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/app/home'
  },
  {
    path: '/user',
    name: 'Account',
    component: UserLayout,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '../views/user/Login.vue'),
        meta: {
          isAuthenticated: false
        }
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import(/* webpackChunkName: "forgot-password" */ '../views/user/ForgotPassword.vue'),
        meta: {
          isAuthenticated: false
        }
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import(/* webpackChunkName: "register" */ '../views/user/Register.vue'),
        meta: {

        }
      },
      {
        path: 'confirm-account/:userId/:token',
        name: 'ConfirmAccount',
        component: () => import(/* webpackChunkName: "confirm-account" */ '../views/user/ConfirmAccount.vue'),
        meta: {

        }
      },
      {
        path: 'confirm-reset-password/:userId/:token',
        name: 'ConfirmResetPassword',
        component: () => import(/* webpackChunkName: "confirm-reset-password" */ '../views/user/ConfirmResetPassword.vue'),
        meta: {

        }
      }
    ]
  },
  {
    path: '/app',
    name: 'app',
    component: Layout,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
        meta: {
          title: 'Dashboard',
          breadcrumbs: [ ]
        }
      },
      {
        path: 'our-vision',
        name: 'ourVision',
        component: () => import(/* webpackChunkName: "our-vision" */ '../views/OurVision.vue'),
        meta: {
          title: 'Our Vision',
          breadcrumbs: [ 'Home' ]
        }
      },
      {
        path: 'our-story',
        name: 'ourStory',
        component: () => import(/* webpackChunkName: "our-story" */ '../views/OurStory.vue'),
        meta: {
          title: 'Our Story',
          breadcrumbs: [ 'Home' ]
        }
      },
      {
        path: 'courses',
        name: 'Courses',
        component: () => import(/* webpackChunkName: "courses" */ '../views/Courses.vue'),
        meta: {
          title: 'Courses',
          breadcrumbs: [ 'Home' ]
        }
      },
      {
        path: 'course/:id',
        name: 'CourseDetails',
        component: () => import(/* webpackChunkName: "course" */ '../views/Course.vue'),
        meta: {
          title: 'View Course',
          breadcrumbs: [ 'Home', 'Courses' ]
        }
      },
      {
        path: 'account',
        name: 'UserAccount',
        component: () => import(/* webpackChunkName: "account" */ '../views/Account.vue'),
        meta: {
          title: 'Course',
          breadcrumbs: [ 'Home' ],
          isAuthenticated: true
        }
      },
      {
        path: 'cart',
        name: 'Cart',
        component: () => import(/* webpackChunkName: "cart-layout" */ '../views/cart/Layout.vue'),
        children: [
          {
            path: 'details',
            name: 'CartDetails',
            component: () => import(/* webpackChunkName: "cart-details" */ '../views/cart/Details.vue'),
            meta: {
              title: 'Cart Details',
              breadcrumbs: [ 'Home' ]
            }
          }
        ]
      },
      {
        path: 'admin',
        name: 'admin',
        component: AdminLayout,
        children: [
          {
            path: 'calendar',
            name: 'AdminCalendar',
            component: () => import(/* webpackChunkName: "admin-calendars" */ '../views/admin/Calendars.vue'),
            meta: {
              title: 'Calendar',
              breadcrumbs: [ 'Home' ],
              isAuthenticated: true,
              role: ['Admin', 'SuperAdmin']
            }
          },
          {
            path: 'coupon',
            name: 'AdminCoupon',
            component: () => import(/* webpackChunkName: "admin-coupon" */ '../views/admin/Coupons.vue'),
            meta: {
              title: 'Coupon',
              breadcrumbs: [ 'Home' ],
              isAuthenticated: true,
              role: ['Admin', 'SuperAdmin']
            }
          },
          {
            path: 'course-mapping',
            name: 'AdminCourseMapping',
            component: () => import(/* webpackChunkName: "admin-course-mapping" */ '../views/admin/CourseMapping.vue'),
            meta: {
              title: 'Course Mapping',
              breadcrumbs: [ 'Home' ],
              isAuthenticated: true,
              role: ['Admin', 'SuperAdmin']
            }
          },
          {
            path: 'calendar/:id',
            name: 'AdminCalendarEdit',
            component: () => import(/* webpackChunkName: "admin-calendar" */ '../views/admin/Calendar.vue'),
            meta: {
              title: 'Edit Calendar',
              breadcrumbs: [ 'Home', 'AdminCalendar' ],
              isAuthenticated: true,
              role: ['Admin', 'SuperAdmin']
            }
          },
          {
            path: 'price-categories',
            name: 'AdminPriceCategory',
            component: () => import(/* webpackChunkName: "admin-price-categories" */ '../views/admin/PriceCategories.vue'),
            meta: {
              title: 'Price Categories',
              breadcrumbs: [ 'Home' ],
              isAuthenticated: true,
              role: ['Admin', 'SuperAdmin']
            }
          },
          {
            path: 'price-category/:id',
            name: 'AdminEditPriceCategory',
            component: () => import(/* webpackChunkName: "admin-price-category" */ '../views/admin/PriceCategory.vue'),
            meta: {
              title: 'Edit Price Category',
              breadcrumbs: [ 'Home', 'AdminPriceCategory' ],
              isAuthenticated: true,
              role: ['Admin', 'SuperAdmin']
            }
          }
        ]
      }
    ]
  }
];

// Register hooks
Component.registerHooks([ 'beforeRouteEnter', 'beforeRouteUpdate', 'beforeRouteLeave' ]);

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

export default router
